const localizationData = {
    en: {
        lang: 'en',
        schedulerTitle: "Great! Please provide your contact info and confirm below.",
        schedulerButtonText: "Confirm My Appointment",
        tosText: "By clicking \"Confirm My Appointment\" you agree to our <a target=\"blank\" href=\"/terms-of-services\">Terms of Service</a>. This includes permission to communicate with you about your appointments via phone, email, or SMS. If you prefer to opt-out of SMS communications you may uncheck this box",
        thankyouTitle: "Confirm My Appointment",
        apppointmentConfirmationText: "Your appointment is scheduled and confirmed. We'll also send a confirmation email with this info for your convenience.",
        waitText: "We're scheduling your appointment...",
        nameField: "First Name",
        lastnameField: "Last Name",
        emailField: "Email",
        phoneField: "Phone",
        businessNameField: "Business Name",
        industry: "Industry",
        areasNeedingHelp: "What can we help you with?",
        expected1stYearRevenue: "Expected Annual Revenue",
        ctaButton: "Schedule My Free Call",
        headerStartFree: "Start for Free",
        meetingWith: 'Meeting with',
        alreadyHasAccount: 'Already have an account?',
        appointmentText: 'Appointment',
        confirmText: 'Confirm',
        scheduler: {
            title: 'Accounting for Everything',
            sub_title:
                'Nationwide tax and accounting services for small businesses, provided by local CPAs.',
            additional_copy:
                'Choose the best time, provide some basic info, and we’ll give you a call.',
            accountant_details: {
                image: {
                    url: '/images/Susan_Young_color.png',
                    alt: 'Susan Young headshot',
                },
                name: 'Susan Young',
                job_title: '1-800Accountant Specialist',
            },
            paid_campaign: true,
            is_stimulus: false,
        },
        form: {
            lead_source: '1-800Accountant',
            lead_type: 'Join Now',
            title: 'Great! We need a little more information to schedule your appointment.',
            service_type: 'Accounting',
            button_text: 'Confirm my Appointment',
        },
        thank_you: {
            title: 'Talk To You Soon!',
            sub_title:
                "Your appointment is scheduled and confirmed. We'll also send a confirmation email with this info for your convenience.",
            calendar_event_title: 'Accounting Consultation',
            calendar_event_description: '',
        },
    },
    es: {
        lang: 'es',
        schedulerTitle: "¡Genial! Necesitamos un poco mas de información para confirmar su cita.",
        schedulerButtonText: "Reservar mi Reunión",
        tosText: "Al hacer clic en \"Reservar mi Reunión\" confirma que ha leído y acepta nuestros <a target='\"'blank\" href=\"/terms-of-services\">Términos de Servicio</a>. Esto incluye el permiso para comunicarnos con usted acerca de nuestros servicios. Si prefiere optar por no recibir comunicaciones por mensaje de texto, puede desmarcar esta casilla",
        thankyouTitle: "¡Hablamos Pronto!",
        apppointmentConfirmationText: "Su cita esta programada y confirmada. Tambien le enviaremos un correo electrónico de confirmación con esta información para su conveniencia.",
        waitText: "Estamos esperando tu reunión...",
        nameField: "We're scheduling your appointment...",
        nameField: "Nombre",
        lastnameField: "Apellido",
        emailField: "Correo electrónico",
        phoneField: "Teléfono",
        businessNameField: "Nombre del negocio",
        industry: "Industria",
        areasNeedingHelp: "¿En qué podemos ayudarte?",
        expected1stYearRevenue: "Ingreso estimado anualmente",
        ctaButton: "Programar Mi Llamada Gratuita",
        headerStartFree: "Empiece Gratis",
        meetingWith: 'Cita con',
        alreadyHasAccount: '¿Ya tenés cuenta?',
        appointmentText: 'Cita',
        confirmText: 'Confirmar',
        scheduler: {
            title: 'Contabilidad para todo',
            sub_title:
                'Servicios de impuestos y contabilidad a nivel nacional para pequeñas empresas, proporcionado por contadores locales',
            additional_copy:
                'Elija el mejor momento, proporcione información básica y te llamaremos',
            accountant_details: {
                image: {
                    url: '/images/Susan_Young_color.png',
                    alt: 'Susan Young headshot',
                },
                name: 'Susan Young',
                job_title: 'Especialista de 1-800Accountant',
            },
            paid_campaign: true,
            is_stimulus: false,
        },
        form: {
            lead_source: '1-800Accountant',
            lead_type: 'Join Now',
            title: '¡Genial! Necesitamos un poco mas de información para confirmar su cita.',
            service_type: 'Contabilidad',
            button_text: 'Confirmar mi cita',
        },
        thank_you: {
            title: "¡Hablamos Pronto!",
            sub_title:
                "Su cita esta programada y confirmada. Tambien le enviaremos un correo electrónico de confirmacion con esta informacion para su conveniencia.",
            calendar_event_title: 'Consultoría contable',
            calendar_event_description: '',
        },
    }
};

export default localizationData;
